import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton, Button, Paper, Slide, Avatar, Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { formatTimeAgo } from "./KeosInboxNotification"; // Reuse your existing utility

const KeosNotificationWidget = ({ notification, onClose, onMarkRead }) => {
  const [visible, setVisible] = useState(true);
  const [timer, setTimer] = useState(null);

  // Auto-close after 30 seconds
  useEffect(() => {
    const autoCloseTimer = setTimeout(() => {
      handleClose();
    }, 30000);

    setTimer(autoCloseTimer);

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => {
      onClose();
    }, 300); // Match the slide animation duration
  };

  const handleActionClick = (url) => {
    window.open(url, "_blank");
    handleClose();
  };

  const handleMarkRead = () => {
    if (onMarkRead) {
      onMarkRead(notification.id);
    }
    handleClose();
  };

  return (
    <Slide direction="right" in={visible} mountOnEnter unmountOnExit>
      <Paper
        sx={{
          position: "fixed",
          bottom: 20,
          left: 20,
          width: 350,
          maxWidth: "90%",
          zIndex: 9999,
          boxShadow: 3,
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            p: 2,
            bgcolor: "background.paper",
            borderLeft: "4px solid",
            borderColor: "primary.main",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {notification.attachment?.url && (
                <Avatar src={notification.attachment.url} alt={notification.attachment.name} sx={{ width: 40, height: 40 }} />
              )}
              <Typography variant="subtitle1" fontWeight="bold">
                {notification.title || "New Notification"}
              </Typography>
            </Box>
            <IconButton size="small" onClick={handleClose} sx={{ ml: 1, color: "text.secondary" }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <Typography variant="body2" sx={{ mb: 1 }}>
            {notification.message}
          </Typography>

          {notification.tags?.length > 0 && (
            <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", mb: 1 }}>
              {notification.tags.map((tag, index) => (
                <Chip key={index} label={tag} size="small" variant="outlined" sx={{ fontSize: "0.65rem" }} />
              ))}
            </Box>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 1,
            }}
          >
            <Typography variant="caption" color="text.secondary">
              {formatTimeAgo(notification.time)}
            </Typography>

            <Box sx={{ display: "flex", gap: 1 }}>
              {notification.click && (
                <Button
                  variant="outlined"
                  size="small"
                  endIcon={<OpenInNewIcon fontSize="small" />}
                  onClick={() => handleActionClick(notification.click)}
                  sx={{ textTransform: "none" }}
                >
                  View
                </Button>
              )}
              <Button variant="text" size="small" onClick={handleMarkRead} sx={{ textTransform: "none" }}>
                Mark as read
              </Button>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Slide>
  );
};

export default KeosNotificationWidget;
